import http from "utils/http";
import { user } from "constants/endpoints";

const updatePassword = ({ email, password, confirmPassword, shortcode }) => {
  const ENDPOINT = user.updatePassword({ shortcode });
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.put(`${API_BASE_URL}${ENDPOINT}`, {
    data: {
      email,
      password,
      confirmPassword,
    },
  });
};

export default updatePassword;
